var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow2Down = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "10.333 7.667 9.333 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.416 8.252v11.466l-3.123-3.136a.56.56 0 0 0-.795 0 .566.566 0 0 0 0 .799l4.104 4.121c.22.22.576.22.795 0l4.104-4.121a.566.566 0 0 0 0-.799.56.56 0 0 0-.795 0l-3.123 3.136V8.252A.59.59 0 0 0 15 7.667a.59.59 0 0 0-.583.585"
})));
export default SvgArrow2Down;